
 <div class="modal-header">
  <h4 class="modal-title">{{title}}</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.close('Cancelar')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <p>{{msg}}</p>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-danger" (click)="activeModal.close('Cancelar')">Cancelar</button>
  <button type="button" class="btn btn-outline-primary" (click)="activeModal.close('Aceptar')">Aceptar</button>
</div>

